import React, { useRef } from 'react';
import  { Container, Row, Col, Card, Form, Tab, Tabs, Button, Breadcrumb } from 'react-bootstrap';
import Header from '../page-layout/header/Header';
import NavMenu from '../navigation/Navmenu';
import Footer from '../page-layout/footer/Footer';
import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { CreateChallenge, GetChallengeById, UpdateChallenge, getpdfUploadLink, uploadPdf } from '../../utils/axios/ChallengesAPI';
import { TimerAlert, ConfirmAlert } from '../../utils/swtAlert';
import { Decrypt } from '../../utils/Helper';
import moment from "moment";
import { GrokLoading } from '../page-layout/loading/Loading';
import { GetLookUps } from '../../utils/axios/LookUpAPI';
import { ROLE } from "../constants/constants";

function ChallengesDetail(props) {
    const [userInfo, setuserInfo] = useState(JSON.parse(Decrypt(sessionStorage.getItem('userInfo'))));
    const navigate = useNavigate();
    const location = useLocation();
    const [validated, setValidated] = useState(false);
    const [isUpdate, setIsUpdate] = useState();
    const [loading, setLoading] = useState(true);
    const [currentTab, setCurrentTab] = useState(0);
    const [apiResponse, setResponse] = useState('');
    const [isChallengeSaved, setIsChallengeSaved] = useState(false);
    //Form Control Variables Starts..
    const [title, setTitle] = useState('');
    const [industryType, setIndustryType] = useState('');
    const [challengeBrief, setChallengeBrief] = useState('');
    const [evaluatedBrief, setEvaluatedBrief] = useState('');
    const [challengeStatus, setChallengeStatus] = useState(1);
    const [notificationStatus, setNotificationStatus] = useState(0);
    const [industryTypeList, setIndustryTypeList] = useState([]);
    const [pdfUpload, setPdfUpload] = useState('');
    const [postingDate, setPostingDate] = useState('');
    const [closingDate, setClosingDate] = useState('');
    //Form Control Variables Ends..

    const pdfRef = useRef();
    const BackBtn = () => {
        navigate('/industryusecase', { state: { challengeid: null } });
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.stopPropagation();
            setValidated(true);
        }
        else {
            SaveChallenge();
        }
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && event.target.tagName === 'INPUT') {
          event.preventDefault();
        }
    };

    const bindFormPreloadData = async () => {
        let industryTypePayLoad = {
            Type: 3,
        }
        setLoading(true);
        var industryTypeResponse = await GetLookUps(industryTypePayLoad);
        setIndustryTypeList(industryTypeResponse.data);
        setLoading(false);
    }

    const bindFormData = async () => {
        if (location.state.challengeid != null) {
            setLoading(true);
            var challengeResponse = await GetChallengeById(location.state.challengeid);
            setLoading(false);
            setTitle(challengeResponse.data[0].Title);
            setIndustryType(challengeResponse.data[0].IndustryType.Id);
            setChallengeBrief(challengeResponse.data[0].ChallengeBrief);
            setEvaluatedBrief(challengeResponse.data[0].EvaluatedBrief);
            setChallengeStatus(challengeResponse.data[0].ChallengeStatus);
            setNotificationStatus(challengeResponse.data[0].NotificationStatus);
            setPdfUpload(challengeResponse.data[0].PdfUpload);
            setClosingDate(moment(challengeResponse.data[0].ClosingDate).format("YYYY-MM-DD"));
            setPostingDate(moment(challengeResponse.data[0].PostingDate).format("YYYY-MM-DD"));

            
            let industryTypePayLoad = {
                Type: 3,
            }
            setLoading(true);
            var industryTypeResponse = await GetLookUps(industryTypePayLoad);
            setLoading(false);

            var selectedIndustryType = industryTypeResponse.data.find((item) => item.Name === challengeResponse.data[0].IndustryType);
            setIndustryType(selectedIndustryType._id);
        }
    }
    const SaveChallenge = async () => {
        let challengePayload = {
            OrganizationId: (userInfo.RoleId === ROLE.GROK_ADMIN && isUpdate) ? location.state.organizationid : userInfo.OrganizationId,
            Title: title,
            IndustryType: industryType,
            ChallengeStatus: challengeStatus,
            NotificationStatus: notificationStatus,
            ClosingDate: closingDate,
        }
        //Edit a challenge
        if (location.state.challengeid != null && (currentTab == 1)) {
            challengePayload.ChallengeBrief = challengeBrief;
            challengePayload.EvaluatedBrief = evaluatedBrief;
            challengePayload.PdfUpload = pdfUpload?.name == undefined ? pdfUpload : pdfUpload?.name.replace(/ /g, "_");
            challengePayload.UpdatedBy = userInfo._id;

            setLoading(true);
            var response = await UpdateChallenge(challengePayload, location.state.challengeid);
            
            if (response && pdfUpload?.name) {
                let pdfUploadLink = await getpdfUploadLink(response.id, pdfUpload.name.replace(/ /g, "_"));
                if (pdfUploadLink.success) {
                    let uploadResponse = await uploadPdf(pdfUploadLink.uploadUrl, pdfUpload);
                    uploadResponse.status === 200 ? console.log("Uploaded successfully") : console.log("error...")
                }
            }
            setLoading(false);
            if (response.message) {
                TimerAlert('Usecase Updation Failed', 'Oops Something Went Wrong', 'error');
            }
            else {
                var delay = TimerAlert('success', 'Usecase Updated Successfully', 'success');
                setTimeout(() => navigate("/industryusecase"), delay);
            }
        }
        else if (location.state.challengeid != null && (currentTab == 0)) {
            //
        }
        else {
            //Create challenge on clicking next
            if (location.state.challengeid == null && currentTab === 0) {
                challengePayload.CreatedBy = userInfo._id;
                
                setLoading(true);
                var response = await CreateChallenge(challengePayload);
                setResponse(response);
                setLoading(false);
            }
            //update the challenge after creating...
            else {

                challengePayload.ChallengeBrief = challengeBrief;
                challengePayload.EvaluatedBrief = evaluatedBrief;
                challengePayload.PdfUpload = pdfUpload.name == undefined ? pdfUpload : pdfUpload.name
                challengePayload.UpdatedBrief = userInfo._id;

                setLoading(true);
                var response = await UpdateChallenge(challengePayload, apiResponse.id);
                if (pdfUpload !== "") {
                    let pdfUploadLink = await getpdfUploadLink(apiResponse.id, pdfUpload.name);
                    if (pdfUploadLink.success) {
                        let uploadResponse = await uploadPdf(pdfUploadLink.uploadUrl, pdfUpload);
                        uploadResponse.status === 200 ? console.log("Uploaded successfully") : console.log("error...")
                    }
                }
                setLoading(false);
                if (response.message) {
                    TimerAlert('Usecase Creation Failed', 'Oops Something Went Wrong', 'error');
                }
                else {
                    var delay = TimerAlert('success', 'Usecase Created Successfully', 'success');
                    setTimeout(() => navigate("/industryusecase"), delay);
                }
            }
        }
    }
    const clearState1 = () => {
        setTitle("");
        setIndustryType("");
        setChallengeBrief("");
        setEvaluatedBrief("");
        setNotificationStatus("");
        setPdfUpload("");
        setClosingDate("");
        pdfRef.current.value = '';
    };
    const clearState2 = () => {
        setChallengeBrief("");
        setEvaluatedBrief("");
        setPdfUpload("");
        pdfRef.current.value = '';
    };
    const clear = (clear) => {
        if (clear === 1) {
            ConfirmAlert("Do you want to clear this data!", 'Are you sure?', 'warning', 'Confirm')
            .then((result) => {
                if (result.isConfirmed) {
                    clearState1();
                }
            });  
        }
        else {
            ConfirmAlert("Do you want to clear this data!", 'Are you sure?', 'warning', 'Confirm')
            .then((result) => {
                if (result.isConfirmed) {
                    clearState2();
                }
            }); 
        }
    };
    
    const handleNext = async () => {
        if(!title || !industryType || !closingDate){
            setValidated(true);
        }
        else{
            if (!isChallengeSaved) {
                await SaveChallenge();
            }
            setIsChallengeSaved(true);
            setCurrentTab((prev) => prev + 1);
            setValidated(false);
        }
    }

    const addRefresh = () => {
        navigate('/home', {state: {challengeid: null}});
    }

    const handleChallenge = () => {
        navigate('/industryusecase', {state: {challengeid: null}});
    }
    
    useEffect(() => {
        bindFormPreloadData();
        bindFormData();
        if (location.state.challengeid != null) {
            setIsUpdate(true);
        }
        else {
            setIsUpdate(false);
        }
        
        const currentDate = new Date();
        const formattedDate = currentDate.toISOString().split('T')[0];
        setPostingDate(formattedDate);
        document.querySelectorAll(".navbar-nav .nav-item a")[2].classList.add("active");
    }, [])

    return (
        <div className='page'>
        {loading ? <GrokLoading /> : ""}
            <NavMenu />
            <Header />

            <div className='page-wrapper'>
                <Container fluid>
                    {/* Start Page Header */}
                    <div className='page-header d-print-none'>
                        <Row className='g-2 align-items-center'>
                            <div>
                                <Breadcrumb className="custom-breadcrumb">
                                    <Breadcrumb.Item onClick={() => addRefresh()}>Home</Breadcrumb.Item>
                                    <Breadcrumb.Item onClick={() => handleChallenge()}> Industry UseCases</Breadcrumb.Item>
                                    <Breadcrumb.Item active>UseCase Details</Breadcrumb.Item>
                                </Breadcrumb>
                            </div>
                            <Col>
                                {!isUpdate && <h2 className="page-title">Add UseCase</h2>}
                                {isUpdate && <h2 className="page-title">Edit UseCase</h2>}
                            </Col>
                            <Col lg={2} className="mb-1" >
                                <Form.Group >
                                    <button className='newBtn_style' onClick={() => BackBtn()}>
                                        <span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M249.38 336L170 256l79.38-80m-68.35 80H342"></path><path fill="none" strokeMiterlimit="10" strokeWidth="32" d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"></path></svg></span>
                                        &nbsp;&nbsp;Back
                                    </button>
                                </Form.Group>
                            </Col>
                        </Row>
                    </div>
                    {/* End Page Header */}

                    <div className='py-3'>
                        <Row className='g-2 justify-content-center'>

                            <Col className='col-lg-10 mb-4'>
                                <Card className='card-hover-shadow'>
                                    <Card.Body>
                                        {/* <Card.Title className='fw-bold mb-3'>Add Student Information:</Card.Title> */}

                                        <Form autoComplete="off" noValidate validated={validated} onKeyDown={handleKeyDown} onSubmit={handleSubmit}> 
                                            <div className='card-tabsmain mb-3'>
                                                <Tabs activeKey={currentTab} transition={false} id="controlled-tab-example">
                                                    <Tab eventKey="0" title="UseCase Details" activeKey={currentTab} disabled={currentTab !== 0}>
                                                        <div className='card-details-boxs'>
                                                            <Row className='my-3'>
                                                                <Col lg={4}>
                                                                    <Form.Group className="mb-3">
                                                                        <Form.Label >UseCase Title <em className="Required">*</em> </Form.Label>
                                                                        <div className='col'>
                                                                            <Form.Control type="text" id="Title" minLength={3} placeholder="Enter usecase title" value={title} onChange={(e) => setTitle(e.target.value)}required />
                                                                            <Form.Control.Feedback type="invalid">UseCase Title is required </Form.Control.Feedback>
                                                                        </div>
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col lg={4}>
                                                                    <Form.Group className="mb-3">
                                                                        <Form.Label>Industry Vertical <em className="Required">*</em></Form.Label>
                                                                        <div className='col'>
                                                                            <Form.Select required as="select" value={industryType} onChange={(e) => setIndustryType(e.target.value)}>
                                                                                <option value={""}>Select</option>
                                                                                {industryTypeList.map((item) => 
                                                                                    <option key={item._id} value={item._id}>{item.Name}</option>
                                                                                )}
                                                                            </Form.Select>
                                                                            <Form.Control.Feedback type="invalid">Industry Type is required </Form.Control.Feedback>
                                                                        </div>
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col lg={4}>
                                                                    <Form.Group className="mb-3">
                                                                        <Form.Label> Posting Date <em className="Required">*</em></Form.Label>
                                                                        <div className="col">
                                                                            <Form.Control type="Date" className='readOnly' id="PostingDate" value={postingDate} onChange={(e) => setPostingDate(e.target.value)} required readOnly/>
                                                                            <Form.Control.Feedback type="invalid">Posting Date is required</Form.Control.Feedback>
                                                                        </div>
                                                                    </Form.Group>
                                                                </Col>
                                                                 <Col lg={4}> 
                                                                    <Form.Group className="mb-3">
                                                                        <Form.Label> Closing Date <em className="Required">*</em></Form.Label>
                                                                        <div className="col">
                                                                            <Form.Control type="Date" id="Closing Date" min={postingDate} value={closingDate} onChange={(e) => setClosingDate(e.target.value)} required />
                                                                            <Form.Control.Feedback type="invalid">Closing Date is required</Form.Control.Feedback>
                                                                        </div>
                                                                    </Form.Group>
                                                                </Col>
                                                                {userInfo.RoleId === ROLE.GROK_ADMIN && <Col lg={4}>
                                                                    <Form.Group className="mb-3">
                                                                        <Form.Label>Publish</Form.Label> 
                                                                        <div className='col'>
                                                                            <Form.Check type="switch" id="NotificationStatus" checked={notificationStatus} onChange={(e) => setNotificationStatus(e.target.checked)}/>
                                                                        </div>
                                                                    </Form.Group>
                                                                </Col>}
                                                                <Row>
                                                                    <Col xs={4}>
                                                                        <Button variant="danger" type="button" size="sm" aria-label="small button" onClick={() => clear(1)}>Clear</Button>
                                                                    </Col>
                                                                    <Col>
                                                                        <div className="d-flex gap justify-content-end">
                                                                            <Button variant="secondary" type="button" size="sm" aria-label="small button" onClick={() => handleNext((prev) => prev + 1)} >Next</Button>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            </Row>
                                                        </div>
                                                    </Tab>
                                                    <Tab eventKey="1" title="Use Case Technical details" disabled={currentTab !== 1}>
                                                        <div className='card-detail-boxs'>
                                                            <Row className='my-3'>
                                                                <Row>
                                                                    <Col lg={12}>
                                                                        <Form.Group className="mb-3">
                                                                            <Form.Label>Use Case Details<em className="Required">*</em></Form.Label>
                                                                            <div className='col'>
                                                                                <Form.Control as="textarea" type="text" id="challengeBrief" style={{ height: '280px' }} minLength={3} placeholder="Enter use case details" value={challengeBrief} onChange={(e) => setChallengeBrief(e.target.value)} required />
                                                                                <Form.Control.Feedback type="invalid">Use Case is required</Form.Control.Feedback>
                                                                            </div>
                                                                        </Form.Group>
                                                                    </Col>
                                                                <Row>
                                                                </Row>
                                                                    <Col lg={12}>
                                                                        <Form.Group className="mb-3">
                                                                            <Form.Label>Evaluation Criteria<em className="Required">*</em></Form.Label>
                                                                            <div className='col'>
                                                                                <Form.Control as="textarea" type="text" id="EvaluateBrief" style={{ height: '280px' }} minLength={3} placeholder="Enter evalution criteria" value={evaluatedBrief} onChange={(e) => setEvaluatedBrief(e.target.value)} required />
                                                                                <Form.Control.Feedback type="invalid">Evaluation Brief is required</Form.Control.Feedback>
                                                                            </div>
                                                                        </Form.Group>
                                                                    </Col>
                                                                </Row>
                                                                <Row className="my-2">
                                                                    <Col lg={4}>
                                                                        <Form.Group className="mb-3">
                                                                            <Form.Label>Technical Details(Pdf Upload)</Form.Label>
                                                                            <div className='col'>
                                                                                <Form.Control ref={pdfRef} accept="application/pdf" type="file" onChange={(e) => setPdfUpload(e.target.files[0])}/>
                                                                            </div>
                                                                        </Form.Group>
                                                                    </Col>                                                                    
                                                                    {pdfUpload && <Col lg={6}>
                                                                        <Form.Group className="mb-3">
                                                                            <div className='col' style={{ marginTop: "2.345rem", color:"#058798" }}>
                                                                                {pdfUpload.name ? pdfUpload.name : pdfUpload}
                                                                            </div>
                                                                        </Form.Group>
                                                                    </Col>}
                                                                </Row>
                                                                <div>
                                                                    <Row>
                                                                        <Col>
                                                                            <Col xs={4}>
                                                                                <Button variant="danger" type="button" size="sm" aria-label="small button" color="error" onClick={() => clear(2)}> Clear</Button>
                                                                            </Col>
                                                                        </Col>
                                                                        <Col>
                                                                            <div className="d-flex gap justify-content-end">
                                                                                <Button variant="secondary" type="button" size="sm" aria-label="small button" onClick={() => setCurrentTab((prev) => prev - 1)} >Prev</Button>
                                                                                <Button variant="success" size="sm" aria-label="small button" type="submit">Save</Button>
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                </div>
                                                            </Row>
                                                        </div>
                                                    </Tab>
                                                </Tabs>
                                            </div>
                                        </Form>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </div>

                </Container>

                <Footer />
            </div>
        </div>
    )
}
export default ChallengesDetail;
